<template>
  <div class="share-bar">
    <div class="ewm-wrap" :class="{ cur: showEwm }">
      <img :src="contact.wxQr" />
    </div>
    <ul>
      <!-- B站、微信、微博、TAP、贴吧 确认 -->
      <li
        class="contant-item wx"
        @mouseenter="hoverWx(1)"
        @mouseout="hoverWx(0)"
      ></li>
      <li class="contant-item wb" @click="toShareLink('wbUrl')"></li>
      <li class="contant-item tap" @click="toShareLink('tapUrl')"></li>
      <li class="contant-item bl" @click="toShareLink('bilibiliUrl')"></li>
      <li class="contant-item tb" @click="toShareLink('tbUrl')"></li>
      <a class="contant-item nga" @click="toShareLink('ngaUrl')"></a>
    </ul>
  </div>
</template>
<script>
import { mapState } from "vuex";
import utils from "@/libs/utils";
const _hmt = window._hmt;
export default {
  name: "ShareBar",
  data: () => ({
    showEwm: 0
  }),
  computed: {
    ...mapState(["contact"])
  },
  methods: {
    hoverWx(show) {
      this.showEwm = show;
      if (show) {
        _hmt.push(["_trackEvent", "index", "wxClick", utils.checkOperaSys()]);
      }
    },
    showWxToast() {
      this.$store.dispatch("changeShowWxToast", true);
      _hmt.push(["_trackEvent", "index", "wxClick", utils.checkOperaSys()]);
    },
    toShareLink(plat) {
      _hmt.push([
        "_trackEvent",
        "index",
        plat + "Click",
        utils.checkOperaSys()
      ]);
      window.open(this.contact[plat], "_blank");
    }
  }
};
</script>
<style lang="less" scoped>
@import "../assets/css/mixin.less";
.share-bar {
  position: absolute;
  .mixin_com(top, 22);
  .mixin_com(left, 70);

  z-index: 1;
  .mixin_com(width, 390);
  .mixin_com(height, 25);

  background:
    url("~@/assets/images/share/share-bar-bg.png?v=1.0") no-repeat
    center;
  background-size: contain;
  .contant-item {
    .mixin_com(width, 25);
    .mixin_com(height, 25);
    .mixin_com(margin-left, 12);
    .mixin_com(margin-right, 12);

    float: left;
    cursor: pointer;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    opacity: 0.9;
    .transition(0.3s);
    &:hover {
      opacity: 1;
      .transform(scale(1.2));
    }
    &.wx {
      .mixin_com(margin-left, 70);

      background-image: url("~@/assets/images/share/share-wx.png");
    }
    &.wb {
      .mixin_com(margin-left, 14);

      background-image: url("~@/assets/images/share/share-wb.png");
    }
    &.tap {
      background-image: url("~@/assets/images/share/share-tap.png");
    }
    &.tb {
      .mixin_com(margin-left, 8);

      background-image: url("~@/assets/images/share/share-tb.png");
    }
    &.bl {
      .mixin_com(margin-left, 17);

      background-image: url("~@/assets/images/share/share-bl.png");
    }
    &.nga {
      .mixin_com(margin-left, 5);

      background-image: url("~@/assets/images/share/share-nga.png");
    }
  }
  .ewm-wrap {
    position: absolute;
    .mixin_com(top, 10);
    .mixin_com(left, 42);
    .mixin_com(width, 82);
    .mixin_com(height, 82);

    opacity: 0;
    .transition(0.3s);
    &.cur {
      .transform(translateY(20px));

      opacity: 1;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
